import { connect } from "react-redux";

import {
    addExplanatoryNoteAction,
    getExplanatoryNoteAction,
    removeAttachmentAction,
} from "../../../Engine/ActionCreators/AttachmentActionCreators";
import { getExpertErrorLog } from "../../../Engine/ActionCreators/ErrorLogActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withCandyApiDraftClient } from "../../withCandyApiDraftClient";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { ExpertNote } from "./ExpertNote";

interface ExpertNoteContainerProps {
    bindingPath: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: ExpertNoteContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    return {
        attachment: viewModelSelect.controlModel(state, bindingPath).children?.[0],
        errorLog: state.errorLog.expert,
        isReadOnly: Boolean(state.settings.isReadOnly),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: ExpertNoteContainerProps) => ({
    getExpertErrorLog: () => dispatch(getExpertErrorLog),
    getExplanatoryNote: () => dispatch(getExplanatoryNoteAction),
    onAddExplanatoryNote: (noteLink: undefined | string) =>
        dispatch(addExplanatoryNoteAction(ownProps.bindingPath, noteLink)),
    onReplaceExplanatoryNote: async (attachmentInstance: string, noteLink: undefined | string) => {
        await dispatch(removeAttachmentAction(ownProps.bindingPath, attachmentInstance));
        await dispatch(addExplanatoryNoteAction(ownProps.bindingPath, noteLink));
    },
});

export const ExpertNoteContainer = withResolvePaths(
    withViewModelSelect(
        withCandyApiDraftClient(connect(mapStateToProps, mapDispatchToProps)(withControlDebugInfo(ExpertNote)))
    )
);
